// extracted by mini-css-extract-plugin
export default {"main":"postLoginLayout_main__V-SXM"};